import React, { useEffect, useState } from "react";
import "./Banner.css";
import requests from "../../utils/requests";

export default function Banner() {
  const [movie, setMovie] = useState([]);
  const baseUrl = "https://api.themoviedb.org/3";
  //fetchdata cho banner
  const fetchData = async (url) => {
    try {
      const response = await fetch(baseUrl + url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  //fectch data originals hiển thị ngẫu nhiên
  useEffect(() => {
    const fetchNetflixOriginalsData = async () => {
      const data = await fetchData(requests.fetchNetflixOriginals);
      const randomIndex = Math.floor(Math.random() * data.results.length);
      setMovie(data.results[randomIndex]);
    };
    fetchNetflixOriginalsData();
  }, []);
  console.log(movie);
  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
        backgroundPosition: "center center",
      }}
    >
      <div className="banner-contents">
        <h1 className="banner-title">
          {movie.name ? movie.name : "name of movie"}
        </h1>
        <div className="banner-button">
          <button className="banner-button-play">Play</button>
          <button className="banner-button-list">My List</button>
        </div>
        <p className="banner-description">
          {movie.overview ? movie.overview : null}
        </p>
      </div>
    </header>
  );
}
